import { createReducer } from "redux-create-reducer";

import { UPDATE_WATCH_LIST_ENTRY } from "../types";

const initialState = {
  isLoading: false,
};

const updateWatchListEntryReducer = createReducer(initialState, {
  [UPDATE_WATCH_LIST_ENTRY.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [UPDATE_WATCH_LIST_ENTRY.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [UPDATE_WATCH_LIST_ENTRY.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [UPDATE_WATCH_LIST_ENTRY.FULFILLED]: (state) => ({
    ...state,
    isLoading: false,
  }),
});

export default updateWatchListEntryReducer;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/reducers/updateWatchListEntryReducer.js